import {Component, Input} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {Observable} from "rxjs";

@Component({
  templateUrl: "./project-customer-error-messages-dialog.template.pug",
})

export class ProjectCustomerErrorMessagesDialogComponent
  extends DialogComponent<any, any> {
  _errorMessages: any;

  @Input()
  public set errorMessages(data: any) {
    this._errorMessages = data.map(d => JSON.parse(d));
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }

  static showDialog(dialogService: DialogService, data: any): Observable<null> {
    return dialogService.addDialog(ProjectCustomerErrorMessagesDialogComponent, data, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }
}
